"use strict";

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 2019-04-11
 */

var immutable_1 = require("immutable");

var CodebookLookupSequence_1 = require("../../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NumberInRangeValidator_1 = require("../../../core/model/data-dictionary/validators/NumberInRangeValidator");

var NumberRangeValidator_1 = require("../../../core/model/data-dictionary/validators/NumberRangeValidator");

var DomainObject_1 = require("../../../core/model/DomainObject");

var NumberRange_1 = require("../../../core/model/math/NumberRange");

var ObjectUtils_1 = require("../../../core/utils/ObjectUtils"); //tslint:disable:max-classes-per-file

/**
 * <p>Partial of {@link SelloutRelease} including its identification and {@link SelloutRelease.itemFilter}.</p>
 *
 * @author JMe
 */


var SelloutReleaseItemFilterPartial =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutReleaseItemFilterPartial, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param id Corresponds to {@link SelloutRelease.id}.
   * @param itemFilter Corresponds to {@link SelloutRelease.itemFilter}.
   */
  function SelloutReleaseItemFilterPartial(id, itemFilter) {
    var _this;

    _classCallCheck(this, SelloutReleaseItemFilterPartial);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemFilterPartial).call(this));
    _this.id = id;
    _this.itemFilter = itemFilter;
    return _this;
  }

  return SelloutReleaseItemFilterPartial;
}(DomainObject_1.DomainObject);

exports.SelloutReleaseItemFilterPartial = SelloutReleaseItemFilterPartial;
/**
 * <p>Specification of {@link SelloutReleaseItem release item} selection as defined by user (LOG-3628) and RFC 318 (PROFACT-166). Can be
 * extended with additional item selection fields.</p>
 *
 * <p>This entity is persisted, instances are stored on {@link SelloutRelease release entity} (field {@link SelloutRelease.itemFilter}).</p>
 *
 * @author Radek Beran
 * @author JMe
 */

var SelloutItemFilter =
/*#__PURE__*/
function (_DomainObject_1$Domai2) {
  _inherits(SelloutItemFilter, _DomainObject_1$Domai2);

  /**
   * Ctor.
   *
   * @param zoneId Identification of {@link PriceZone} which determines set of {@link InternalSite sites} we are interested in. If null,
   *        it basically means all available sites (the national price zone).
   * @param siteIds Other restrictive criteria that may further limit the set of {@link InternalSite sites} we are interested in. When
   *        used in conjunction with a zone filter, the resulting set of sites will be the intersection of that set and the set determined
   *        from the zone.
   * @param weighted Determines whether we are interested in so called weighted {@link Product products}. True means we do, false means
   *        we are interested in not weighted products, null means it does not matter (both weighted and not weighted will be used).
   * @param endDateFrom Lower bound for {@link SelloutSupply.delistedFrom delist date} of {@link SelloutSupply sellout item}. The value is
   *        entered by user within form of header of release.
   * @param endDateTo Upper bound for delist date of sellout item. The value is entered by user within form of header of release.
   * @param returnable Determines whether we are interested in so called returnable items. True means we do, false means
   *        we are interested in not returnable products, null means it does not matter (both returnable and not returnable will be used).
   */
  function SelloutItemFilter(zoneId, siteIds, weighted, unitsPerSite, stockValue, selloutVolume, futurePromoInWeeks, daysToExpiration, endDateFrom, // it would be better to group this and endDateTo to a single DateRange.
  endDateTo, // it would be better to group this and endDateFrom to a single DateRange.
  productExternalIds, returnable) {
    var _this2;

    _classCallCheck(this, SelloutItemFilter);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SelloutItemFilter).call(this));
    _this2.zoneId = zoneId;
    _this2.siteIds = siteIds;
    _this2.weighted = weighted;
    _this2.unitsPerSite = unitsPerSite;
    _this2.stockValue = stockValue;
    _this2.selloutVolume = selloutVolume;
    _this2.futurePromoInWeeks = futurePromoInWeeks;
    _this2.daysToExpiration = daysToExpiration;
    _this2.endDateFrom = endDateFrom;
    _this2.endDateTo = endDateTo;
    _this2.productExternalIds = productExternalIds;
    _this2.returnable = returnable;
    return _this2;
  }
  /**
   * @returns True if this instance of filter contains no criteria set, false otherwise.
   */


  _createClass(SelloutItemFilter, [{
    key: "isEmpty",
    value: function isEmpty() {
      return this.hashCode() === SelloutItemFilter.EMPTY_HASH_CODE;
    }
    /**
     * @returns True if only any filtering specification related to {@link ISelloutItemBaseFilter} is filled, false otherwise.
     */

  }, {
    key: "isEmptyExceptBase",
    value: function isEmptyExceptBase() {
      if (this.isEmpty()) {
        return false; // nothing is filled, no filtering specification related to ISelloutItemBaseFilter is filled.
      }

      var copyWithBase = SelloutItemFilter.EMPTY.copyMulti({
        endDateFrom: this.endDateFrom,
        endDateTo: this.endDateTo
      });
      return this.hashCode() === copyWithBase.hashCode();
    }
    /**
     * @returns True if data should be limited by stock value in any way, false otherwise.
     */

  }, {
    key: "isFilterByStockValueIncluded",
    value: function isFilterByStockValueIncluded() {
      return !this.stockValue.isUnbounded();
    }
    /**
     * @returns True if data should be limited by sellout volume in any way, false otherwise.
     */

  }, {
    key: "isFilterBySelloutVolumeIncluded",
    value: function isFilterBySelloutVolumeIncluded() {
      return !this.selloutVolume.isUnbounded();
    }
    /**
     * @returns True if data should be filtered by filter of stock value or sellout volume, false if by neither.
     */

  }, {
    key: "isFilterBySelloutVolumeOrStockValueIncluded",
    value: function isFilterBySelloutVolumeOrStockValueIncluded() {
      return this.isFilterByStockValueIncluded() || this.isFilterBySelloutVolumeIncluded();
    }
    /**
     * @returns Hash code calculated from JSON.stringified object of this instance.
     */

  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(JSON.stringify(this));
    }
  }]);

  return SelloutItemFilter;
}(DomainObject_1.DomainObject);

exports.SelloutItemFilter = SelloutItemFilter;
SelloutItemFilter.EMPTY = new SelloutItemFilter(null, immutable_1.Set(), null, NumberRange_1.NumberRange.EMPTY, NumberRange_1.NumberRange.EMPTY, NumberRange_1.NumberRange.EMPTY, 0, NumberRange_1.NumberRange.EMPTY, null, null, null, null);
SelloutItemFilter.EMPTY_HASH_CODE = ObjectUtils_1.ObjectUtils.hashCode(JSON.stringify(SelloutItemFilter.EMPTY));

SelloutItemFilter.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutItemFilter.name);
  return {
    zoneId: builder.opt(builder.str('zoneId')),
    siteIds: builder.setOf(builder.lookup('sitesIds', CodebookLookupSequence_1.CodebookLookupSequence.InternalSites)),
    weighted: builder.opt(builder.bool('weighted')),
    unitsPerSite: builder.obj('unitsPerSite', NumberRange_1.NumberRange.schema, function (mat) {
      return new NumberRange_1.NumberRange(mat.minimum, mat.maximum);
    }, new NumberRangeValidator_1.NumberRangeValidator(0, null)),
    stockValue: builder.obj('stockValue', NumberRange_1.NumberRange.schema, function (mat) {
      return new NumberRange_1.NumberRange(mat.minimum, mat.maximum);
    }, new NumberRangeValidator_1.NumberRangeValidator(0, null)),
    selloutVolume: builder.obj('selloutVolume', NumberRange_1.NumberRange.schema, function (mat) {
      return new NumberRange_1.NumberRange(mat.minimum, mat.maximum);
    }, new NumberRangeValidator_1.NumberRangeValidator(0, null)),
    futurePromoInWeeks: builder.num('futurePromoInWeeks', new NumberInRangeValidator_1.NumberInRangeValidator(0, null)),
    daysToExpiration: builder.obj('daysToExpiration', NumberRange_1.NumberRange.schema, function (mat) {
      return new NumberRange_1.NumberRange(mat.minimum, mat.maximum);
    }, new NumberRangeValidator_1.NumberRangeValidator(0, null, NumberRangeValidator_1.NumberRangeValidator.DEFAULT_FROM_TO_KEYS_DESC)),
    endDateFrom: builder.opt(builder.date('endDateFrom', DateParser_1.DateParser.ISO_PATTERN)),
    endDateTo: builder.opt(builder.date('endDateTo', DateParser_1.DateParser.ISO_PATTERN)),
    productExternalIds: builder.opt(builder.setOf(builder.str('productExternalIds'))),
    returnable: builder.opt(builder.bool('returnable'))
  };
}();